export default __webpack_public_path__ + "static/media/UrgentTreatmentCentre-NorthumberlandUECNUTCClinicianComms(1).a5316b60.jpg";